import { Component } from '@angular/core';
import { Field } from '@shared/components/dynamic-form/models/field.interface';
import { FieldConfig } from '@shared/components/dynamic-form/models/field-config.interface';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-link-result',
  templateUrl: './link-result.component.html',
  styleUrls: ['./link-result.component.scss']
})
export class LinkResultComponent  implements Field {
  config: FieldConfig;
  group: FormGroup;
}
